module.exports = __webpack_public_path__ + "media/images/lineup__stat__prevScore-79d430e73de9b7ba4ffed5611d364463.png";